import { type ReactNode } from 'react';
import { CssBaseline, ThemeProvider as MuiThemeProvider } from '@mui/material';
import { useTheme } from 'next-themes';
import { theme } from '@/theme';
import type { ThemeMode } from '@/theme';

export default function ThemeProvider({ children }: { children: ReactNode }) {
  const { resolvedTheme } = useTheme();
  return (
    <MuiThemeProvider theme={theme(resolvedTheme as ThemeMode)}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
}
